import { MapContentLayer } from '../MapContentLayer';
import { FilterSpecification, LayerSpecification, SymbolLayerSpecification, Map } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { MapPreviewComponent } from '../../map-preview.component';

export class ObservationIconLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('observation-icon-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'symbol',
      source: this.sourceRef.sourceId,
      layout: {
        'icon-image': MapPreviewComponent.STAR_IMAGE,
        'icon-allow-overlap': true,
      },
      paint: {
        'icon-color': 'white',
      },
    } as SymbolLayerSpecification;
  }

  filterByTime(map: Map, timeFrom: number, timeTo: number) {
    const filter: any[] = ['all'];
    if (!!timeFrom) {
      filter.push(['>=', ['get', 'time'], timeFrom]);
    }
    if (!!timeTo) {
      filter.push(['<=', ['get', 'time'], timeTo]);
    }

    map.setFilter(
      this.layerId,
      filter as FilterSpecification,
    );
  }
}
